module.exports = [{"image":"live-laugh-legume","text":"Live, Laugh, Legume!"},{"image":"boom","text":"Boom!"},{"image":"check-out-this-spread","text":"Check Out This Spread!"},{"image":"go-nuts","text":"Go Nuts"},{"image":"think-outside-the-jar","text":"Think Outside The Jar!"},{"image":"youre-welcome","text":"You're Welcome!"},{"image":"youve-been-served","text":"You've Been Served!"}]


//////////////////
// WEBPACK FOOTER
// ./src/scripts/data/headlines.json
// module id = 30
// module chunks = 0